import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UserManagementComponent } from "./user-management/user-management.component";
import { UserDialogComponent } from "./user-management/Forms/user-dialog.component";
import { SharedModule } from "src/app/shared/shared.module";
import { RoleDialogComponent } from "./user-management/Forms/role-dialog/role-dialog/role-dialog.component";
import { UserManangementRoutingModule } from "./user-manangement-routes";

@NgModule({
  declarations: [
    UserManagementComponent,
    UserDialogComponent,
    RoleDialogComponent,
  ],
  imports: [CommonModule, SharedModule, UserManangementRoutingModule],
})
export class UserManagementModule {}
